import { Button, ButtonProps } from "@chakra-ui/react";
import { forwardRef } from "react";
import { Link as RouterLink, To } from "react-router";

interface RouterLinkButtonProps extends Omit<ButtonProps, "as"> {
  to: To;
}

export const RouterLinkButton = forwardRef<
  HTMLButtonElement,
  RouterLinkButtonProps
>(({ to, isDisabled, ...props }, ref) => {
  if (isDisabled) {
    return <Button ref={ref} isDisabled {...props} />;
  }

  return <Button ref={ref} as={RouterLink} to={to} {...props} />;
});

RouterLinkButton.displayName = "RouterLinkButton";
